module.exports = __webpack_public_path__ + "onboarding-feed-vsts.8a215e5485d6e7183df474ff989eb6ca.hashedasset.svg";


//////////////////
// WEBPACK FOOTER
// ./app/img/library/empty/onboarding-feed-vsts.svg
// module id = 5832179158248372
// module chunks = 1